module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/4-b708588f3c10f99cfc7fc896555ad48f.svg";